module.exports = __webpack_public_path__ + "img/code.0938091c.png";